export type StatusType = 'active' | 'pending' | 'suspended' | 'completed' | 'rejected' | 'inactive';

const statusConfig: Record<
  StatusType,
  { bg: string; text: string; dot: string; border: string; label?: string }
> = {
  active: {
    bg: 'bg-cyan-50',
    text: 'text-cyan-700',
    dot: 'bg-cyan-500',
    border: 'border-cyan-100',
  },
  completed: {
    bg: 'bg-cyan-50',
    text: 'text-cyan-700',
    dot: 'bg-cyan-500',
    border: 'border-cyan-100',
  },
  pending: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    dot: 'bg-amber-500',
    border: 'border-amber-100',
  },
  suspended: {
    bg: 'bg-rose-50',
    text: 'text-rose-700',
    dot: 'bg-rose-500',
    border: 'border-rose-100',
  },
  rejected: {
    bg: 'bg-rose-50',
    text: 'text-rose-700',
    dot: 'bg-rose-500',
    border: 'border-rose-100',
  },
  inactive: {
    bg: 'bg-slate-50',
    text: 'text-slate-500',
    dot: 'bg-slate-400',
    border: 'border-slate-200',
  },
};

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
}

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const config = statusConfig[status];
  const displayLabel = label ?? status;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold uppercase tracking-wider border ${config.bg} ${config.text} ${config.border}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot} mr-1.5`} />
      {displayLabel}
    </span>
  );
}
